import React from "react";
import { ScreenProps } from "../types";
import { Button } from "./Common";
import "./index.css";

function MultiplayerScreen(props: ScreenProps) {
  const { dispatch } = props;
  const loadLabel = "#multiplayer-load";
  const gotoWaveLoader = () =>
    dispatch({ type: "screen/changeScreen", payload: { screen: loadLabel } });
  const goToWaveCreator = () => dispatch({ type: "state/empty" });

  return (
    <div id="multiplayer-select-screen">
      <Button label="Load Wave" onClick={gotoWaveLoader} />
      <Button label="Create Wave" onClick={goToWaveCreator} />
    </div>
  );
}

export default MultiplayerScreen;
